import { useWidgetBlockReducer } from './state-management/useWidgetBlockReducer';
import * as redux from './state-management/export';
import WidgetBlock from './state-management/WidgetBlock';
import './style.scss';

const providers = {
    redux,
    useWidgetBlockReducer,
    WidgetBlock,
};

export { providers };
export * from './AllWidgetBlocks';
